import * as React from "react";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { addDroppedFile, cleanDroppedFilesRepertoireState, clearModalSearchResults, incrementTempID, setEditableFields, setProgressUploadFileRepertoireProccess } from "../../../../redux/reducers/MembersPortalReducer";
import { IUsageGroupState, IUsageGroupStateKeys } from "../../../../redux/types/IUsageGroupState";
import { SizedDropdownDataInput } from "../../../../repertoire/components/dropdownDataInput/DropdownDataInput";
import { getLookupValues } from "../../../../lookup/services/LookupHelpers";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";

import { USAGE_GROUP_VENUE_TYPE_LOOKUP, USAGE_GROUP_VENUE_DETAILS_TYPE_LOOKUP, LICENSING_VENUE_LOOKUP, USAGE_GROUP_PERFORMANCE_TYPE_LOOKUP, PORTAL_DEFAULT_VALUES_LOOKUP, } from "../../../../lookup/Consts";
import { SizedTextDataInput } from "../../../../repertoire/components/textDataInput/TextDataInput";
import { ADD_NEW_DATE_ACTION, LIVE_PERFORMANCE_END_TIME_STATE_KEY, LIVE_PERFORMANCE_LOCATION_STATE_KEY, LIVE_PERFORMANCE_OTHER_ARTIST_PERFORM_STATE_KEY, LIVE_PERFORMANCE_PERFORMANCE_DATE_STATE_KEY, LIVE_PERFORMANCE_PERFORMANCE_TYPE_STATE_KEY, LIVE_PERFORMANCE_PERFORMER_STATE_KEY, LIVE_PERFORMANCE_PROMOTER_STATE_KEY, LIVE_PERFORMANCE_SET_LIST_STATE_KEY, LIVE_PERFORMANCE_STAGE_STATE_KEY, LIVE_PERFORMANCE_START_TIME_STATE_KEY, LIVE_PERFORMANCE_STATE_KEY, LIVE_PERFORMANCE_VENUE_CONTACT_FIRST_NAME_STATE_KEY, LIVE_PERFORMANCE_VENUE_CONTACT_LAST_NAME_STATE_KEY, LIVE_PERFORMANCE_VENUE_CONTACT_PHONE_NUMBER_STATE_KEY, LIVE_PERFORMANCE_VENUE_OTHER_VENUE_TYPE_STATE_KEY, LIVE_PERFORMANCE_VENUE_TYPE_STATE_KEY, LIVE_PERFORMANCE_VENUE_LOOKUP_TYPE_STATE_KEY, SEARCH_VIEW_DRAFT_SET_LISTS, SET_LIST_MODAL_SEARCH_VIEW, REGISTER_VENUE, GOOGLE_VENUE, LIVE_PERFORMANCE_VENUE_CONTACT_REGION_STATE_KEY, LIVE_PERFORMANCE_VENUE_NAME_STATE_KEY, LIVE_PERFORMANCE_VENUE_CODE_STATE_KEY } from "../../../Consts";
import { hideModal, showModal, showUpdateFieldsModal } from "../../../../redux/reducers/ModalReducer";
import { IMembersPortalField } from "../../../types/IMembersPortalField";
import { SizedCheckboxDataInput } from "../../../../repertoire/components/checkboxDataInput/CheckboxDataInput";
import DataGridTable from "../../../../repertoire/components/dataGridTable/DataGridTable";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { MEMBERS_PORTAL } from "../../../../accounts/Consts";
import SimpleTimeDataInput from "../../../../repertoire/components/timeFieldDataInput/SimpleTimeDataInput";
import SizedDatePickerDataInput from "../../../../repertoire/components/dateDataInput/DatePickerDataInput";
import { LICENSE_VENUES_KEY, LIVE_PERFORMANCE_PAGE_VIEW, SEARCH_VIEW, SET_LIST_ADDITIONAL_VENUE_TYPE, VENUE_CODE, VENUE_NAME, VENUES_KEY } from "../../../../repertoire/Consts";
import MapSearch from "../../../components/maps/MapSearch";
import { IUsageGroupLocation } from "../../../../repertoire/types/usageTypes/IUsageGroupLocation";
import { CleanUploadFilesState, addFileToUpload, fileMetadataChanged, setInDropZone, setProgressUploadFileProccess, sortColumn, updatePagination } from "../../../../redux/reducers/DataIngestionReducer";
import { IComponentDataItem } from "../../../../core/types/IComponentDataItem";
import { ILookupInstance } from "../../../../lookup/types/ILookup";
import { IDistribution } from "../../../../repertoire/types/usageTypes/IDistribution";
import IDroppedFiles from "../../../../redux/types/IDroppedFiles";
import { IFileSystem } from "../../../../dataingestion/types/IFileSystem";
import { DataSource } from "../../../../repertoire/types/DataSource";
import { MembersPortalService } from "../../../../redux/services/MembersPortalService";
import { IAttachedFile } from "../../../../redux/types/IAttachedFile";
import { IStoragePathItemData } from "../../../../dataingestion/types/IStoragePathItemData";
import { ITreeData } from "../../../../repertoire/types/ITreeData";
import { IRemoveWorkBlobAttachment } from "../../../../repertoire/types/IRemoveWorkBlobAttachment";
import { FormatFields } from "../../../../redux/types/FormatFields";
import { IPaginationDetail } from "../../../../redux/types/IPaginationDetail";
import { SizedActionButton } from "../../../../repertoire/components/actionButton/ActionButton";

import ScrollEventListenerWrapperContainerDetailsWindow from "../../../../dataingestion/components/containerDetailsWindow/ScrollEventListenerWrapperContainerDetailsWindow";
import SelectorView from "../../../../repertoire/components/selectorView/SelectorView";
import {formatDateToHourAndMinutes} from "../../../util/dateHelpers";
import { ILicenseCustomerVenue } from "../../../../repertoire/types/ILicenseCustomerVenue";
import { IUsageGroupVenueDetails } from "../../../../repertoire/types/usageTypes/IUsageGroupVenueDetails";
import { ICustomerVenue } from "../../../../repertoire/types/ISetListVenue";
import { EXTERNAL_SVG } from "../../../../repertoire/IconConsts";
import ShowMore from "../../../../repertoire/components/showMore/ShowMore";

import { Dayjs } from 'dayjs';
export interface ILivePerformanceMaintenanceGeneralDataViewProps {
    livePerformanceMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem;
    dataGridTableData?: IRepertoireComponentDataItem;
    usage: IUsageGroupState;
    isReadOnly: boolean;
    lookupValues: ILookupDictionary;
    editableFields: any[];
    isNewLivePerformance?: boolean;
    updateLivePerformanceField: (value: any, fieldName: IUsageGroupStateKeys, index?: number) => void;
    resetMessageBanner: () => void;
    changesMade: boolean;
    updateComponentFieldsItems?: (fields: IMembersPortalField[],
        componentName: string,
        componentInstance: string,
        componentDataFieldName: string,
        tabs: ITabReduxItem[],
        activeTab: number) => void;
    showUpdateFieldsModal?: typeof showUpdateFieldsModal;
    editableFieldsDataView?: IMembersPortalComponentDataItem;
    dataGridTableEditableFieldsData?: IMembersPortalComponentDataItem;
    setEditableFields?: typeof setEditableFields;
    activeTab: number;
    tabs: ITabReduxItem[];
    showModal?: typeof showModal;
    hideModal?: typeof hideModal;
    incrementTempID?: () => void;
    activeHeaderSection?: string;
    isMandatory?: boolean;
    livePerformanceMaintenanceGridsViewData: IMembersPortalComponentDataItem;
    addFileToUpload: typeof addFileToUpload;
    cleanUploadFilesState: typeof CleanUploadFilesState;
    containerDetailsWindowComponentData: IComponentDataItem;
    destinations: ILookupInstance[];
    distributions: IDistribution[];
    droppedFiles: IDroppedFiles;
    isDropZone: boolean;
    selectedFileSystem: IFileSystem;
    setInDropZone: typeof setInDropZone;
    setProgressUploadFileProccess: typeof setProgressUploadFileProccess;
    sortColumn: typeof sortColumn;
    storagePathItemData: IComponentDataItem;
    attachedFiles: IStoragePathItemData[];
    refreshDirectory: (filesystem: IFileSystem, sources: ITreeData[]) => void;
    addRepertoireAttachmentToState: (attachedFile: IAttachedFile) => void;
    removeWorkAttachmentIfExists: (attachedFile: IAttachedFile, source: DataSource) => void;
    addDroppedFileRepertoire?: typeof addDroppedFile;
    workAttachmentsDropped?: IDroppedFiles;
    cleanDroppedFilesRepertoire: typeof cleanDroppedFilesRepertoireState;
    setProgressUploadFileRepertoire: typeof setProgressUploadFileRepertoireProccess;
    refreshWorkDetails: (dataSource: string, workID: number, lookups: ILookupDictionary, otherIndicatorsWorkFlagTypes: string[], activeTabItem: ITabReduxItem, readonlyIndicatorsWorkFlagTypes: string[], formats?: FormatFields[]) => void;
    dataSource: DataSource;
    paginationDetails: IPaginationDetail[];
    updatePagination: typeof updatePagination;
    getDataIngestionComponentData?: () => void;
    currentUserNameNumber: string;
    googleVenueSelected?: boolean;
    regVenueSelected?: boolean;
    isVenueRegEnabled?: boolean;
    isGoogleVenueRegEnabled?: boolean;
    licenseVenues?: ILicenseCustomerVenue[];
    venueDetails?: IUsageGroupVenueDetails;
    customerVenues?: ICustomerVenue[];


    disabledDate?: (current: Dayjs) => boolean;
    client?: string;
}

interface ILivePerformanceGeneralDataViewState {
    loaded: boolean;
    activeHeaderSection?: string;
    googleVenueSelected?: boolean;
    regVenueSelected?: boolean;
    isRegReadonly?: boolean;
    isVenueRegEnabled?: boolean;
    isGoogleVenueRegEnabled?: boolean;
    regVenueType: string;
    newVenueDetailsValue: IUsageGroupVenueDetails;
    isEditable?: boolean;
}


export default class LivePerformanceMaintenanceGeneralDataView extends React.PureComponent<
    ILivePerformanceMaintenanceGeneralDataViewProps,
    ILivePerformanceGeneralDataViewState> {
    viewData;
    constructor(props: ILivePerformanceMaintenanceGeneralDataViewProps) {  
        super(props);

        this.state = {
            activeHeaderSection: props.activeHeaderSection ?? "draftWorkWorkProperties",
            loaded: false,
            googleVenueSelected: props.googleVenueSelected ?? false,
            regVenueSelected: true,
            regVenueType: GOOGLE_VENUE,
            newVenueDetailsValue: {} as IUsageGroupVenueDetails,
            isEditable: false
        };
        this.viewData = {};
    }

    componentDidMount() {
        const {
            livePerformanceMaintenanceGeneralDataViewData: { fields }
        } = this.props;

        if (fields) {
            const visibleFields = fields.filter(field => !field.hidden);

            visibleFields.forEach(item => {
                this.viewData[item.name] = item.data;

                if (Object.keys(this.viewData).length === visibleFields.length) {
                    this.setState({ loaded: true });
                }
            });
        }

    }

    
    componentDidUpdate(prevProps: Readonly<ILivePerformanceMaintenanceGeneralDataViewProps>, prevState: Readonly<ILivePerformanceGeneralDataViewState>, snapshot?: any): void {
       
        if (prevProps.licenseVenues !== this.props.licenseVenues) {
            const licenseVenues = this.props.licenseVenues || [];
            if (licenseVenues.length > 0) {
                const venue = licenseVenues[0];
                let venueType = '';
                if (venue.venueType) {
                    const lookupVenueType = getLookupValues(USAGE_GROUP_VENUE_TYPE_LOOKUP, this.props.lookupValues).find(x => String(x.typeID) === String(venue.venueType));
                    venueType = lookupVenueType ? lookupVenueType.code : '';
                }
                this.setState({
                    ...this.state,
                    newVenueDetailsValue: {
                        ...this.state.newVenueDetailsValue,
                        venueCode: venue.venueCode as string,
                        venueName: venue.venueName,
                        venueType: venueType,
                    }
                });
            }
        }
    }

    onClickHeaderSection = (activeHeaderSection: string) => {
        this.setState({
            activeHeaderSection
        });
    };

    showFieldsModal = () => {

    }

    onClick = (fieldName: string) => {
        if (this.props.showModal) {
            this.props.showModal(
                SEARCH_VIEW, 
                SET_LIST_MODAL_SEARCH_VIEW, 
                { isReadOnly: false, isUsageSearchArtist: true },
                true,
                "Search"
            );
        }
    }
    showSearchModal = (searchView: string, licenceView: string) => {
        const { showModal } = this.props;
        clearModalSearchResults();
        
        this.props.showModal(searchView, licenceView, {isReadOnly: false, isUsageSearchArtist: true }, true, "Search");
    };

    renderGridViewHeaderSections = (header: IMembersPortalField, isMandatory = false) => {
        return (
            <div
                className={["headerSection", "activeSection", (isMandatory ? "isMandatory" : "")].join(" ")}
                key={header.name}
                data-testid={header.name + "-section"}            >
                {header.data}
            </div>
        );
    };

    updateGoogleVenue = (venue: IUsageGroupLocation) => {
        const { updateLivePerformanceField } = this.props;
        updateLivePerformanceField(venue, LIVE_PERFORMANCE_LOCATION_STATE_KEY as IUsageGroupStateKeys)
    }

    renderLocationSection = () => {
        const { usage: { location }, livePerformanceMaintenanceGridsViewData, client } = this.props;
        const placeUrl = location && location.googleVenue ? `https://www.google.com/maps/embed/v1/place?key=AIzaSyCkf4i1fmMijSv08OdOlxggXQZRIHb0-oo&q=place_id:${location.googleVenue}` : ""
        return (
            <>
                <div className="marginVerticalVeryLarge"></div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <br></br>
                        <b>{livePerformanceMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'livePerformanceSearchAddress').data} <span className="important-label">*</span></b>
                        <div><MapSearch updateGoogleVenue={this.updateGoogleVenue} client={client} viewData={this.viewData} /></div>
                    </div>
                    <div className="marginVerticalVeryLarge">
                        <div className="marginTopVeryXLarge">
                            <SizedActionButton className={"button btn-outline-defaultPrimary"} buttonAction={this.clearVenueValues} buttonText={this.viewData['clear']} />
                        </div>
                    </div>


                </div>

                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <div className="marginVerticalVeryXLarge">
                        <div className="marginVerticalVeryLarge">
                            {location && location.googleVenue &&
                                <iframe
                                    title="MapsIframe"
                                    width="100%"
                                    height="274"
                                    className="mapFrame"
                                    src={placeUrl}>
                                </iframe>
                            }
                        </div>
                    </div>
                </div>
            </>
        )
        // }

    }

    refreshWorkDetails() {
        const { tabs, activeTab, lookupValues, dataSource } = this.props;
        let currentTab = tabs[activeTab];
        this.props.refreshWorkDetails(
            dataSource,
            currentTab.workMaintenanceState.work.workID,
            lookupValues,
            tabs[activeTab].otherIndicatorWorkFlagTypes,
            currentTab,
            tabs[activeTab].readonlyIndicatorWorkFlagTypes
        )
    }
 
    clearVenueValues = () => {
        const { updateLivePerformanceField } = this.props;
        updateLivePerformanceField('', 'venueCode' as IUsageGroupStateKeys);
        updateLivePerformanceField('', 'venueName' as IUsageGroupStateKeys);
        updateLivePerformanceField('', 'venueLookupType' as IUsageGroupStateKeys);
        updateLivePerformanceField('', 'firstName' as IUsageGroupStateKeys);
        updateLivePerformanceField('', 'lastName' as IUsageGroupStateKeys);
        updateLivePerformanceField('', 'phoneNumber' as IUsageGroupStateKeys);
        updateLivePerformanceField('', 'venueType' as IUsageGroupStateKeys);
        updateLivePerformanceField('', 'otherTypeOfVenue' as IUsageGroupStateKeys);

        if (this.props.usage?.location?.googleVenue) {
            let venue: IUsageGroupLocation = {};
            updateLivePerformanceField('', 'googleVenue' as IUsageGroupStateKeys);
            this.updateGoogleVenue(venue);
        }
    }

    removeAttachmentFromMaintenanceScreen(fullName: string, workId: number, dataSource: DataSource, guid: string, index: number) {
        const attachedFile: IAttachedFile = {
            fileName: fullName,
            workId: workId
        }
        const model: IRemoveWorkBlobAttachment = {
            Guid: guid,
            Source: dataSource,
            workID: workId
        }

        MembersPortalService.removeWorkBlobAttachment(model)
            .then(res => {
                if (res) {
                    MembersPortalService.removeWorkAttachment({ attachedFile: attachedFile, dataSource: dataSource })
                        .then((res: boolean) => {
                            if (res) {
                                this.refreshWorkDetails();
                            }
                        })
                }
            })
    }

    renderForm = (isReadOnly: boolean) => {
        const {
            lookupValues,
            updateLivePerformanceField,
            livePerformanceMaintenanceGridsViewData,
            usage,
            dataGridTableData,
            tabs,
            activeTab,
            addFileToUpload,
            cleanUploadFilesState,
            containerDetailsWindowComponentData,
            destinations,
            distributions,
            droppedFiles,
            isDropZone,
            selectedFileSystem,
            setInDropZone,
            setProgressUploadFileProccess,
            sortColumn,
            storagePathItemData,
            refreshDirectory,
            addRepertoireAttachmentToState,
            removeWorkAttachmentIfExists,
            addDroppedFileRepertoire,
            workAttachmentsDropped,
            cleanDroppedFilesRepertoire,
            setProgressUploadFileRepertoire,
            paginationDetails,
            updatePagination,
            dataSource,
            currentUserNameNumber,
            disabledDate,
            customerVenues
        } = this.props;
        const { fullPerformer, location } = this.props.usage;
        const attachedFiles = this.props.attachedFiles ?? [];
        const { regVenueType } = this.state;

        const isGoogleVenueRegEnabled = () => {
            const lookupResult = getLookupValues(PORTAL_DEFAULT_VALUES_LOOKUP, lookupValues, "PerformanceVenueGoogleOption", "MembersPortal");
            if (lookupResult && lookupResult.length > 0) {
                let enabled = lookupResult[0]?.extraFields?.["Value"];
                return enabled == "true" ? false : true;
            }
            return true;
        }
        const isVenueRegEnabled = () => {
            const lookupResult = getLookupValues(PORTAL_DEFAULT_VALUES_LOOKUP, lookupValues, "PerformanceVenueLookupOption", "MembersPortal");
            if (lookupResult && lookupResult.length > 0) {
                let enabled = lookupResult[0]?.extraFields?.["Value"];
                return enabled == "true" ? false : true;
            }
            return true;
        }

        const onChangeRegVenueType = (regVenueType: string) => {
            this.setState({ regVenueType });
        }

        const changeData = (value: any, fieldName: string) => {

            if (fieldName == "venueLookupType") {
                var selectedVenue = getLookupValues(LICENSING_VENUE_LOOKUP, lookupValues, value, "MembersPortal").find(x => x.code === value);
                var venueType = selectedVenue
                    ? getLookupValues(USAGE_GROUP_VENUE_TYPE_LOOKUP, lookupValues).find(x => String(x.typeID) === String(selectedVenue.typeID))
                    : undefined;

                updateLivePerformanceField(venueType?.code ?? "", LIVE_PERFORMANCE_VENUE_TYPE_STATE_KEY as IUsageGroupStateKeys);
                updateLivePerformanceField(this.props.usage.venueDetails.venueName ?? "", LIVE_PERFORMANCE_VENUE_NAME_STATE_KEY as IUsageGroupStateKeys);

                updateLivePerformanceField(this.props.usage.venueDetails.venueCode ?? "", LIVE_PERFORMANCE_VENUE_CODE_STATE_KEY as IUsageGroupStateKeys);
                updateLivePerformanceField(this.props.usage.venueDetails.firstName ?? "", LIVE_PERFORMANCE_VENUE_CONTACT_FIRST_NAME_STATE_KEY as IUsageGroupStateKeys);
                updateLivePerformanceField(this.props.usage.venueDetails.lastName ?? "", LIVE_PERFORMANCE_VENUE_CONTACT_LAST_NAME_STATE_KEY as IUsageGroupStateKeys);
                updateLivePerformanceField(this.props.usage.venueDetails.phoneNumber ?? "", LIVE_PERFORMANCE_VENUE_CONTACT_PHONE_NUMBER_STATE_KEY as IUsageGroupStateKeys);

                let venue: IUsageGroupLocation = {
                    googleVenue: '',
                    venue: selectedVenue.description,
                    addDetailsManually: true,
                    city: selectedVenue.extraFields["City"] ?? "",
                    country: selectedVenue.extraFields["Country"] ?? "",
                    region: selectedVenue.extraFields["Region"] ?? "",
                }
                this.updateGoogleVenue(venue)
            }
            else if (fieldName === LIVE_PERFORMANCE_VENUE_TYPE_STATE_KEY) {
                const selectedType = getLookupValues(USAGE_GROUP_VENUE_TYPE_LOOKUP, lookupValues).find(x => x.code === value);
                updateLivePerformanceField(selectedType ? selectedType.typeID : value, fieldName as IUsageGroupStateKeys);
            }
            else {
                updateLivePerformanceField(value, fieldName as IUsageGroupStateKeys);
            }
        }

        return (
            <>
                <div className="topMargin">
                    <div className="row">
                        <div className="headerContainer">
                            <h5 dangerouslySetInnerHTML={{__html: livePerformanceMaintenanceGridsViewData.fields.find(x => x.name === "mandatoryField")?.data || ""}}></h5>
                        </div>
                        {<SizedDatePickerDataInput
                            value={usage.usages[0].usageDate.value ? usage.usages[0].usageDate.value : null}
                            fieldName={LIVE_PERFORMANCE_PERFORMANCE_DATE_STATE_KEY}
                            changeData={changeData}
                            label={this.viewData[LIVE_PERFORMANCE_PERFORMANCE_DATE_STATE_KEY]}
                            isHidden={false}
                            isMandatory={true}
                            readOnly={isReadOnly}
                            disabledDate={disabledDate}
                            placeholder={this.viewData["selectDate"]}
                            formatToUTC={false}
                        />}
                        <div className="form-group col-md-4 col-sm-6 col-xs-12">
                            {<SimpleTimeDataInput
                                label={this.viewData[LIVE_PERFORMANCE_START_TIME_STATE_KEY]}
                                value={usage.usages[0].programStartDate.value ? formatDateToHourAndMinutes(usage.usages[0].programStartDate.value) : null}
                                changeData={changeData}
                                fieldName={LIVE_PERFORMANCE_START_TIME_STATE_KEY}
                                isMandatory={true}
                                readonly={isReadOnly}
                            />}
                        </div>

                        <div className="form-group col-md-4 col-sm-6 col-xs-12">
                            {<SimpleTimeDataInput
                                label={this.viewData[LIVE_PERFORMANCE_END_TIME_STATE_KEY]}
                                value={usage.usages[0].programEndDate.value ? formatDateToHourAndMinutes(usage.usages[0].programEndDate.value) : null}
                                changeData={changeData}
                                fieldName={LIVE_PERFORMANCE_END_TIME_STATE_KEY}
                                isMandatory={true}
                                readonly={isReadOnly}
                            />}
                        </div>
                        {<SizedTextDataInput
                            fieldType={"text"}
                            label={this.viewData[LIVE_PERFORMANCE_PERFORMER_STATE_KEY]}
                            fieldName={LIVE_PERFORMANCE_PERFORMER_STATE_KEY}
                            changeData={changeData}
                            readOnly={isReadOnly}
                            isHidden={false}
                            value={fullPerformer}
                            isMandatory={true}
                        />}
                    </div>
                    <div className="row">
                        <div className="headerContainer">
                            {this.renderGridViewHeaderSections(livePerformanceMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'livePerformanceMoreDates'))}
                        </div>
                        <div>
                            <h5>{livePerformanceMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'livePerformanceMoreDatesSectionMessage').data}</h5>
                            <DataGridTable
                                tableContents={usage.moreDates}
                                changeData={changeData}
                                dataGridTableData={dataGridTableData}
                                stateKey={LIVE_PERFORMANCE_STATE_KEY}
                                componentInstance={LIVE_PERFORMANCE_STATE_KEY}
                                showRowNumber={false}
                                isReadOnly={isReadOnly}
                                tableActions={[{ name: ADD_NEW_DATE_ACTION }]}
                                lookupValues={lookupValues}
                                incrementTempID={incrementTempID}
                                tabs={tabs}
                                activeTab={activeTab}
                                showDropdownsAsCodes={false}
                                clearModalSearchResults={clearModalSearchResults}
                                portalType={MEMBERS_PORTAL}
                                showModal={showModal}
                                hideModal={hideModal}
                            />
                        </div>

                    </div>



                    <div className="row">
                        <div className="headerContainer">
                            {this.renderGridViewHeaderSections(livePerformanceMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'livePerformanceLocation'))}
                        </div>
                        <h5>{livePerformanceMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'livePerformanceLocationSectionMessage').data}</h5>

                        <div className="row">
                            <div className="form-group col-md-6 col-sm-6 col-xs-12 ">
                                <div className="searchView">
                                    <div className="col-md-12 col-sm-12 col-xs-12 " hidden={isVenueRegEnabled() || isGoogleVenueRegEnabled()}>
                                        <SelectorView
                                            selection={regVenueType}
                                            setSelection={onChangeRegVenueType}
                                            option1={GOOGLE_VENUE}
                                            option1Label={this.viewData['searchGoogleMaps']}
                                            option2={REGISTER_VENUE}
                                            option2Label={this.viewData['registeredAddress']}
                                            selectorTitle={''}
                                            fullSize={true}
                                            customStyle={'selectorViewCustomTabStyle'}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group col-md-6 col-sm-6 col-xs-12 "></div>
                        </div>



                        {regVenueType === GOOGLE_VENUE ?
                            <>
                                {this.renderLocationSection()}


                            </>

                            : <>
                                <div className="marginVerticalVeryLarge"></div>
                                <div className="col-md-6 col-sm-6 col-xs-12">
                                    <br></br>
                                    {<div className="row usageMaintenanceArtist">
                                                <SizedTextDataInput
                                                    label={this.viewData[VENUE_NAME]}
                                                    value={this.props.usage?.venueDetails?.venueName || ''}
                                                    isHidden={false}
                                                    fieldName={LIVE_PERFORMANCE_VENUE_NAME_STATE_KEY}
                                                    changeData={changeData}
                                                    readOnly={true}
                                                />
																	
                                                <SizedTextDataInput
                                                    label={this.viewData[VENUE_CODE]}
                                                    value={this.props.usage?.venueDetails?.venueCode || ''}
                                                    isHidden={false}
                                                    fieldName={LIVE_PERFORMANCE_VENUE_CODE_STATE_KEY}
                                                    changeData={changeData}
                                                    readOnly={true}
                                                />
                                                <div className="centeredDotting">
                                                    <div>
                                                        <ShowMore
                                                            options={[
                                                                {
                                                                    text: "Venue",
                                                                    onClick: () => {
                                                                        this.setState({
                                                                        newVenueDetailsValue: {
                                                                            ...this.state.newVenueDetailsValue,
                                                                            venueCode: this.props?.licenseVenues? this.props?.licenseVenues[0]?.venueCode : '' as string,
                                                                            venueName: this.props?.licenseVenues ? this.props?.licenseVenues[0]?.venueName : '',
                                                                            region: this.props?.licenseVenues ? this.props?.licenseVenues[0]?.region : ''
                                                                        }
                                                                    })
                                                                        this.setState({ isEditable: true });
                                                                        this.showSearchModal(SEARCH_VIEW, LICENSE_VENUES_KEY);
                                                                    },
                                                                    icon: EXTERNAL_SVG,
                                                                }
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>}
                                    <div className="marginVerticalVeryLarge">
                                        <div className="marginTopVeryXLarge">
                                            <SizedActionButton className={"button btn-outline-defaultPrimary"} buttonAction={this.clearVenueValues} buttonText={this.viewData['clear']} />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="form-group col-md-6 col-sm-6 col-xs-12">

                                    <div className="marginVerticalVeryLarge">

                                    </div>

                                </div>


                            </>}



                    </div>


                    <div className="row"></div>


                    <div className="row">
                        <div className="headerContainer">
                            {this.renderGridViewHeaderSections(livePerformanceMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'livePerformanceVenueDetails'))}
                        </div>

                        {<SizedTextDataInput
                            fieldType={"text"}
                            label={this.viewData[LIVE_PERFORMANCE_VENUE_CONTACT_FIRST_NAME_STATE_KEY]}
                            fieldName={LIVE_PERFORMANCE_VENUE_CONTACT_FIRST_NAME_STATE_KEY}
                            changeData={changeData}
                            readOnly={isReadOnly}
                            isHidden={false}
                            value={usage.venueDetails?.firstName}
                            isMandatory={true}
                        />}
                        {<SizedTextDataInput
                            fieldType={"text"}
                            label={this.viewData[LIVE_PERFORMANCE_VENUE_CONTACT_LAST_NAME_STATE_KEY]}
                            fieldName={LIVE_PERFORMANCE_VENUE_CONTACT_LAST_NAME_STATE_KEY}
                            changeData={changeData}
                            readOnly={isReadOnly}
                            isHidden={false}
                            value={usage.venueDetails?.lastName}
                            isMandatory={true}
                        />}
                        {<SizedTextDataInput
                            fieldType={"text"}
                            label={this.viewData[LIVE_PERFORMANCE_VENUE_CONTACT_PHONE_NUMBER_STATE_KEY]}
                            fieldName={LIVE_PERFORMANCE_VENUE_CONTACT_PHONE_NUMBER_STATE_KEY}
                            changeData={changeData}
                            readOnly={isReadOnly}
                            isHidden={false}
                            value={usage.venueDetails?.phoneNumber}
                            isMandatory={true}
                        />}
                        {<SizedDropdownDataInput
                                label={this.viewData[LIVE_PERFORMANCE_VENUE_TYPE_STATE_KEY]}
                                fieldName={LIVE_PERFORMANCE_VENUE_TYPE_STATE_KEY}
                                changeData={changeData}
                                options={getLookupValues(USAGE_GROUP_VENUE_TYPE_LOOKUP, lookupValues)}
                                readOnly={isReadOnly}
                                allowNull={false}
                                isHidden={false}
                                value={
                                    getLookupValues(USAGE_GROUP_VENUE_TYPE_LOOKUP, lookupValues)
                                        .find(x => String(x.typeID) === String(usage.venueDetails?.venueType))?.code || ""
                                }
                                isMandatory={true}
                        />}
                        {<SizedTextDataInput
                            fieldType={"text"}
                            label={this.viewData[LIVE_PERFORMANCE_VENUE_OTHER_VENUE_TYPE_STATE_KEY]}
                            fieldName={LIVE_PERFORMANCE_VENUE_OTHER_VENUE_TYPE_STATE_KEY}
                            changeData={changeData}
                            readOnly={isReadOnly}
                            isHidden={false}
                            value={usage.venueDetails?.otherTypeOfVenue}
                            isMandatory={false}
                        />}

                    </div>
                    <div className="row">
                        <div className="headerContainer">
                            {this.renderGridViewHeaderSections(livePerformanceMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'livePerformanceSetList'))}
                        </div>
                        {<SizedTextDataInput
                            fieldType={"text"}
                            label={this.viewData[LIVE_PERFORMANCE_SET_LIST_STATE_KEY]}
                            fieldName={LIVE_PERFORMANCE_SET_LIST_STATE_KEY}
                            changeData={changeData}
                            readOnly={isReadOnly}
                            isHidden={false}
                            onClick={this.onClick}
                            clickPrompt={!isReadOnly}
                            value={usage.livePerformanceSetList?.title ? usage.livePerformanceSetList?.title[0] : '...'}
                            isMandatory={true}
                        />}
                    </div>
                    <div className="row">
                        <div className="headerContainer">
                            {this.renderGridViewHeaderSections(livePerformanceMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'livePerformanceProofOfPerformance'), true)}
                        </div>
                        <h5>{livePerformanceMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'livePerformanceProofOfPerformanceSectionMessage').data}</h5>
                        <br></br>
                        <b>{livePerformanceMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'livePerformanceUploadFile').data}</b>
                        {<div className="height">
                            {containerDetailsWindowComponentData.fields.length > 0 && (<ScrollEventListenerWrapperContainerDetailsWindow
                                addFileToUpload={addFileToUpload}
                                cancelChanges={undefined}
                                cleanUploadFilesState={cleanUploadFilesState}
                                containerDetailsWindowComponentData={containerDetailsWindowComponentData}
                                currentDirectory={"usage"}
                                destinations={destinations}
                                editingChanged={undefined}
                                fileMetadataChanged={fileMetadataChanged}
                                jobs={[]}
                                matchNow={undefined}
                                matchNowSubmit={undefined}
                                openDirectory={undefined}
                                pageContentIsActive={true}
                                distributions={distributions}
                                droppedFiles={droppedFiles}
                                isDropZone={isDropZone}
                                selectedFileSystem={selectedFileSystem}
                                setInDropZone={setInDropZone}
                                setProgressUploadFileProccess={setProgressUploadFileProccess}
                                storagePathItemData={storagePathItemData}
                                storagePaths={attachedFiles}
                                refreshDirectory={refreshDirectory}
                                saveChanges={undefined}
                                saveState={undefined}
                                isRepertoireModule={true}
                                toggleSidebarCollapsed={undefined}
                                validationMessageChanged={undefined}
                                addRepertoireAttachmentToState={addRepertoireAttachmentToState}
                                entityID={1}
                                entitySource={dataSource}
                                removeAttachmentIfExists={removeWorkAttachmentIfExists}
                                addDroppedFileRepertoire={addDroppedFileRepertoire}
                                attachmentsDropped={workAttachmentsDropped}
                                cleanDroppedFilesRepertoire={cleanDroppedFilesRepertoire}
                                setProgressUploadFileRepertoire={setProgressUploadFileRepertoire}
                                component={LIVE_PERFORMANCE_PAGE_VIEW}
                                removeAttachmentMaintenanceScreen={this.removeAttachmentFromMaintenanceScreen.bind(this)}
                                displayRemove={true}
                                paginationDetails={paginationDetails}
                                updatePagination={updatePagination}
                                lookupValues={lookupValues}
                                tabs={tabs}
                                activeTab={activeTab}
                                isProductAttachmentTypeNotRequired={true}
                                isProductAttachmentTypeOptional={false}
                                isWorkAttachmentTypeNotRequired={true}
                                isWorkAttachmentTypeOptional={false}
                                currentUserNameNumber={currentUserNameNumber}
								renderDragFilesUpload={true}
								displayResponsiveGrid
                            />)}
                            <br></br>
                        </div>}
                    </div>
                    <div className="row">
                        <div className="headerContainer">
                            {this.renderGridViewHeaderSections(livePerformanceMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'livePerformanceAdditionSection'))}
                        </div>
                        <div className="row">
                            {<SizedDropdownDataInput
                                label={this.viewData[LIVE_PERFORMANCE_PERFORMANCE_TYPE_STATE_KEY]}
                                fieldName={LIVE_PERFORMANCE_PERFORMANCE_TYPE_STATE_KEY}
                                options={getLookupValues(USAGE_GROUP_PERFORMANCE_TYPE_LOOKUP, lookupValues)}
                                changeData={changeData}
                                readOnly={isReadOnly}
                                isHidden={false}
                                value={usage.setListAdditional?.performanceType}
                                isMandatory={false}
                                allowNull={false}
                            />}

                            {<SizedTextDataInput
                                fieldType={"text"}
                                label={this.viewData[LIVE_PERFORMANCE_STAGE_STATE_KEY]}
                                fieldName={LIVE_PERFORMANCE_STAGE_STATE_KEY}
                                changeData={changeData}
                                readOnly={isReadOnly}
                                isHidden={false}
                                value={usage.setListAdditional?.stage}
                                isMandatory={false}
                            />}
                            {<SizedTextDataInput
                                fieldType={"text"}
                                label={this.viewData[LIVE_PERFORMANCE_PROMOTER_STATE_KEY]}
                                fieldName={LIVE_PERFORMANCE_PROMOTER_STATE_KEY}
                                changeData={changeData}
                                readOnly={isReadOnly}
                                isHidden={false}
                                value={usage.setListAdditional?.promoter}
                                isMandatory={false}
                            />}
                        </div>
                        <div className="row">
                            {<SizedCheckboxDataInput
                                label={this.viewData[LIVE_PERFORMANCE_OTHER_ARTIST_PERFORM_STATE_KEY]}
                                fieldName={LIVE_PERFORMANCE_OTHER_ARTIST_PERFORM_STATE_KEY}
                                value={usage.setListAdditional?.otherArtistPerform}
                                changeData={changeData}
                                readonly={isReadOnly}
                            />}
                        </div>

                    </div>
                </div >
            </>
        );
    }

    render() {
        const { usage } = this.props;
        const { loaded } = this.state;

        if (!loaded) {
            return <div />
        }

        let isReadOnly: boolean;

        if (usage.approvalStatus === "Approved" || usage.approvalStatus === "Rejected") {
            isReadOnly = true;
        }
        else {
            isReadOnly = false;
        }

        return this.renderForm(isReadOnly);
    }
}